<div>

  <!-- Reports / Dashboard -->
  <div *ngIf="componentLocation === 'reports' || componentLocation === 'workspace-reports' || componentLocation === 'dashboard'">
    <div class="w-full lg:flex items-center lg:px-0"
         [ngClass]="{
           'justify-center': componentLocation !== 'dashboard',
           'justify-start': componentLocation === 'dashboard',
           'px-3': !(componentLocation === 'dashboard' && showDropdown)
         }">

      <div class="w-full flex items-center space-x-3 relative"
           [ngClass]="{
             'justify-center lg:ml-8 max-w-[40rem]': componentLocation !== 'dashboard',
             'justify-start': componentLocation === 'dashboard'
           }">
        <div class="w-full transform overflow-hidden rounded-xl bg-white ring-1 ring-gray-100 py-0.5 transition-all" [@borderAnimation]="errorMessage ? 'true' : 'false'">
          <div>
            <svg
              class="absolute left-4 top-4 h-5 w-5 text-secondary"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                clip-rule="evenodd"
              />
            </svg>
            <!--
          <input type="text" [(ngModel)]="linkedin" (keydown.enter)="processSearch()" class="h-12 w-full border-0 bg-transparent pl-11 pr-4 text-gray-900 placeholder:text-secondary focus:ring-0 sm:text-sm" placeholder="{{ 'input_linkedin_account_link' | translate }}">
          -->

            <input
              type="text"
              [(ngModel)]="linkedin"
              (input)="onInputChange($event)"
              (keydown.escape)="clearAll()"
              class="h-12 w-full border-0 bg-transparent pl-11 pr-4 lg:pr-28 text-gray-900 placeholder:text-secondary/50 placeholder:font-poppins placeholder:tracking-wide focus:ring-0 sm:text-sm"
              placeholder="Search: name, company name, title, country, linkedin url etc."
            />

            <!-- Clear icon (right) -->
            <svg
              *ngIf="linkedin"
              (click)="clearAll()"
              class="absolute right-4 top-4 h-5 w-5 text-secondary hover:opacity-90 cursor-pointer"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              viewBox="0 0 24 24"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>

          </div>

          <a *ngIf="!linkedin" routerLink="/advanced-search" class="hidden lg:flex absolute bottom-2.5 right-2.5 bg-primary/5 hover:bg-primary/10 rounded-lg border-none py-[0.48rem] px-3 font-poppins text-primary text-xs tracking-wide whitespace-nowrap transition-all duration-300 ease-in-out">
            <span class="font-normal">Prospecting</span>
          </a>

        </div>

        <!--
      <button type="button" (click)="processSearch()" class="bg-secondary p-4 rounded-xl shadow-2xl hover:opacity-90">
        <svg class="h-5 w-5 text-primary-100" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd" />
        </svg>
      </button>
      -->

        <button
          type="button"
          (click)="processSearch()"
          [disabled]="!linkedinUrlValid"
          class="bg-blue-royal shadow-lg shadow-blue-royal/10 p-4 rounded-xl"
          [ngClass]="{
            'opacity-90 cursor-not-allowed': !linkedinUrlValid,
            'hover:opacity-90': linkedinUrlValid
          }"
        >
          <svg
            class="h-5 w-5 text-primary-100"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

      </div>

      <a routerLink="/advanced-search" class="block lg:hidden bg-transparent hover:bg-gray-50 hover:rounded-full border-none px-3 rounded-md font-poppins text-secondary text-xs tracking-wide whitespace-nowrap mt-3">
        <span class="font-normal">Prospecting</span>
      </a>

    </div>
    <span *ngIf="errorMessage" class="hidden md:flex text-xs font-normal justify-center p-2 h-4 text-red-500">{{ errorMessage }}</span>

    <div
      class="absolute mt-3 z-50 w-full"
      [ngClass]="{
        'left-1/2 transform -translate-x-1/2 max-w-3xl': componentLocation !== 'dashboard',
        'left-0': componentLocation === 'dashboard'
      }">

      <!-- Search Person Dropdown -->
      <app-search-person-dropdown
        #dropdown
        *ngIf="showDropdown"
        [query]="linkedin"
        [componentLocation]="componentLocation"
        (resultSelected)="onDropdownSelect($event)"
        class="w-full"
      ></app-search-person-dropdown>
    </div>

  </div>

  <!-- header -->
  <div *ngIf="componentLocation === 'header'">
    <div class="relative flex items-center">
      <div class="relative">
        <input
          id="search"
          name="text"
          [(ngModel)]="linkedin"
          (input)="onInputChange($event)"
          (keydown.escape)="clearAll()"
          class="block md:w-[28rem] lg:w-[37rem] rounded-lg border-0 bg-[#161e52] py-1.5 pl-10 pr-3 lg:pr-28 ring-1 ring-inset ring-transparent text-white placeholder:text-white/50 placeholder:font-poppins placeholder:tracking-wide focus:ring-2 focus:ring-inset focus:ring-transparent sm:text-sm sm:leading-6"
          placeholder="Search: name, company name, title, country, linkedin url etc."
          type="text"
        />
        <svg
          class="absolute left-3 top-2 h-5 w-5 text-secondary"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
            clip-rule="evenodd"
          />
        </svg>

        <!-- Clear icon (right) -->
        <svg
          *ngIf="linkedin"
          (click)="clearAll()"
          class="absolute right-3 top-2 h-5 w-5 text-white/70 hover:text-white cursor-pointer"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          viewBox="0 0 24 24"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>

        <!-- Prospecting pill -->
        <a
          *ngIf="!linkedin"
          routerLink="/advanced-search"
          class="hidden lg:flex absolute top-1.5 right-2 bg-white/10 hover:bg-white/20 rounded-md border-none py-1 px-2.5 font-poppins text-white/80 text-xs tracking-wide whitespace-nowrap transition-all duration-300 ease-in-out"
        >
          <span class="font-normal">Prospecting</span>
        </a>
      </div>

      <button
        type="button"
        [disabled]="!linkedinUrlValid"
        (click)="processSearch()"
        [ngClass]="{
          'opacity-50 cursor-not-allowed': !linkedinUrlValid,
          'hover:opacity-90': linkedinUrlValid
        }"
        class="bg-secondary p-2.5 rounded-xl shadow-2xl hover:opacity-90 ml-3"
      >
        <svg
          class="h-4 w-4 text-primary-100"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <p
      *ngIf="errorMessage"
      class="absolute bg-[#161e52] rounded-md py-1 px-3 text-xs font-normal flex justify-start text-red-500 z-20 mt-1 w-[20rem]"
    >
      {{ errorMessage }}
    </p>

    <div class="absolute mt-3 w-full max-w-3xl z-50">
      <!-- Search Person Dropdown -->
      <app-search-person-dropdown
        #dropdown
        *ngIf="showDropdown"
        [query]="linkedin"
        [componentLocation]="componentLocation"
        (resultSelected)="onDropdownSelect($event)"
        class="w-full"
      ></app-search-person-dropdown>
    </div>
  </div>

  <!-- dashboard -->
  <!--
  <div *ngIf="componentLocation === 'dashboard'">

    <div *ngIf="isVisible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

      <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 transition-opacity"></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

          <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">

            <div>

              <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button type="button" (click)="closeModal(); clearInput()" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none">
                  <span class="sr-only">Close</span>
                  <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div class="sm:flex sm:items-start px-4 py-4 lg:px-6 lg:py-6">

                <div class="mt-3 sm:mt-0 w-full">
                  <h3 class="text-lg text-center font-semibold leading-6 text-gray-900" id="modal-title">Search a new prospect</h3>
                  <div class="mt-6">

                    <div class="sm:col-span-4">

                      <div>
                        <div class="relative mt-2 rounded-md">
                          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 text-gray-400">
                              <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
                            </svg>
                          </div>
                          <input type="text" [(ngModel)]="linkedin" (keydown.enter)="processSearch()" #linkedinInput class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-royal sm:text-sm/6" placeholder="{{ 'input_linkedin_account_link' | translate }}">
                        </div>
                        <p *ngIf="errorMessage" class="text-xs font-normal flex justify-start text-red-500 mt-1">{{ errorMessage }}</p>
                      </div>

                    </div>

                  </div>
                </div>
              </div>

              <div class="px-4 sm:px-6 mb-6 grid grid-cols-2 gap-6">
                <button type="button" (click)="closeModal(); clearInput()" class="block w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button>
                <button type="button" (click)="processSearch()" class="block w-full justify-center rounded-md bg-blue-royal px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-90 sm:w-auto">Search</button>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
  -->
</div>
